import * as Yup from "yup";

export const LENGTH_VALIDATION = (min: number, max: number) =>
  Yup.string()
    .trim()
    .min(min, {
      i18nKey: "min-symbols",
      i18nParams: { count: min },
    })
    .max(max, {
      i18nKey: "max-symbols",
      i18nParams: { count: max },
    })
    .required("required");

export const EMAIL_VALIDATION_SCHEMA = LENGTH_VALIDATION(3, 100)
  .email("incorrect-email")
  .required("required");

const PHONE_REGEX =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

export const PHONE_VALIDATION_SCHEMA = Yup.string()
  .max(15)
  .matches(PHONE_REGEX)
  .required("required");
